import Vue from 'vue';
import feathersClient from '../../feathers-client';

const defaultHiFiAwardsPagination = {
	total: 100,
	$skip: 0,
	$limit: 6,
};

const defaultHiFiAwardsFilter = {
	$skip: defaultHiFiAwardsPagination.$skip,
	$limit: defaultHiFiAwardsPagination.$limit,
};

//staff hifi award
const defaultStaffHiFiAwardsPagination = {
	total: 100,
	$skip: 0,
	$limit: 6,
};

const defaultStaffHiFiAwardsFilter = {
	$skip: defaultStaffHiFiAwardsPagination.$skip,
	$limit: defaultStaffHiFiAwardsPagination.$limit,
};

export default {
	namespaced: true,
	state: {
		hiFiAwards: [],
		hiFiAwardsFilter: defaultHiFiAwardsFilter,
		hiFiAwardsPagination: defaultHiFiAwardsPagination,
		//staff
		staffHiFiAwards: [],
		staffHiFiAwardsFilter: defaultStaffHiFiAwardsFilter,
		staffHiFiAwardsPagination: defaultStaffHiFiAwardsPagination,
	},
	getters: {
		hiFiAwardsPage: (state) => {
			const { $limit, $skip } = state.hiFiAwardsPagination;
			return $skip / $limit + 1;
		},
		staffHiFiAwardsPage: (state) => {
			const { $limit, $skip } = state.staffHiFiAwardsPagination;
			return $skip / $limit + 1;
		},
	},
	mutations: {
		SET_HIFI_AWARDS: (state, hiFiAwards) => { state.hiFiAwards = hiFiAwards; },
		SET_HIFI_AWARDS_PAGINATION: (state, data) => { state.hiFiAwardsPagination = { ...state.hiFiAwardsPagination, ...data }; },
		SET_HIFI_AWARDS_FILTER: (state, filter) => { state.hiFiAwardsFilter = { ...state.hiFiAwardsFilter, ...filter }; },
		SET_DEFAULT_HIFI_AWARDS_FILTER: (state, filter) => { state.hiFiAwardsFilter = { ...filter, ...defaultHiFiAwardsFilter }; },

		//staff
		SET_STAFF_HIFI_AWARDS: (state, staffHiFiAwards) => { state.staffHiFiAwards = staffHiFiAwards; },
		SET_STAFF_HIFI_AWARDS_PAGINATION: (state, data) => { state.staffHiFiAwardsPagination = { ...state.staffHiFiAwardsPagination, ...data }; },
		SET_STAFF_HIFI_AWARDS_FILTER: (state, filter) => { state.staffHiFiAwardsFilter = { ...state.staffHiFiAwardsFilter, ...filter }; },
		SET_DEFAULT_STAFF_HIFI_AWARDS_FILTER: (state, filter) => { state.staffHiFiAwardsFilter = { ...filter, ...defaultStaffHiFiAwardsFilter }; },
	},
	actions: {
		setHiFiAwardsFilter: ({ commit }, filter) => {
			commit('SET_HIFI_AWARDS_FILTER', filter);
		},
		setDefaultHiFiAwardsFilter: ({ commit }, filter) => {
			commit('SET_DEFAULT_HIFI_AWARDS_FILTER', filter);
		},
		//staff
		setStaffHiFiAwardsFilter: ({ commit }, filter) => {
			commit('SET_STAFF_HIFI_AWARDS_FILTER', filter);
		},
		setDefaultStaffHiFiAwardsFilter: ({ commit }, filter) => {
			commit('SET_STAFF_DEFAULT_HIFI_AWARDS_FILTER', filter);
		},
		setHiFiAwardsPage: ({ commit, state }, page) => {
			const $skip = (page - 1) * state.hiFiAwardsPagination.$limit;
			commit('SET_HIFI_AWARDS_PAGINATION', { $skip });
			commit('SET_HIFI_AWARDS_FILTER', { $skip });
		},
		//staff
		setStaffHiFiAwardsPage: ({ commit, state }, page) => {
			const $skip = (page - 1) * state.staffHiFiAwardsPagination.$limit;
			commit('SET_STAFF_HIFI_AWARDS_PAGINATION', { $skip });
			commit('SET_STAFF_HIFI_AWARDS_FILTER', { $skip });
		},
		getHiFiAwards: async({ commit, rootGetters }, filter) => {
			
			const url = '/api/v3/hifi-awards-manager-view'; // shift manager
			const results = await feathersClient.service('/api/v3/hifi-awards-manager-view').find({
				query: {
					$role: rootGetters.currentUserRole,
					...filter,
				},

			});
			
			commit('SET_HIFI_AWARDS', results.data);
			const totalCount = results.total;
			commit('SET_HIFI_AWARDS_PAGINATION', { total: totalCount });
			return results.data;
		},

		getUserPermissionsOfTrust: async ({ rootGetters }, query) => {
			const url = '/api/v3/user-permissions-of-trust'; // trust-admin
			const results = await feathersClient.service(url).find({ query: { $role: rootGetters.currentUserRole, ...query } });
			return results;
		},
		getStaffUserData({ commit }, userData) {
			commit('SET_STAFF_HIFI_AWARDS', userData);
		  },
	},
};
